import React, { useState, useEffect, useRef } from "react";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import BackdropComponent from "../Spinner/Spinner";
import { useSelector, useDispatch } from "react-redux";
import Grid from "@mui/material/Grid";
import SnackBar from "components/SnackBar/SnackBar";
import { SnackBarStoreAction } from "Store/SnackBar";
import { useTranslation } from "react-i18next";
import {
  getTraineeStatus,
  getreasonDetails,
  getRosterID,
  getparentClientList,
  saveRescheduleTransfer,
} from "../../services/userServices";
import classes from "./RescheduleOrTransferDrawer.module.css";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import { Box, IconButton, Typography } from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";
import TextLabel from "components/Common/TextLabel/TextLabel";

const typographyStyle = {
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  letterSpacing: "0.10rem",
  fontWeight: "bold",
  color: "#3F5765",
  paddingBottom: 1,
};

const RescheduleOrTransferDrawer = (props) => {
  const { t } = useTranslation(["rescheduleTransfer"]);
  const {
    fromAssignTrainee,
    classRosterId,
    traineeDetails,
    onClose,
    refreshTraineeList,
  } = props;
  const dispatch = useDispatch();
  const [loading, setLoader] = useState(false);
  const [traineestatusdata, settraineestatusdata] = useState([]);
  const [reasondata, setreasondata] = useState([]);
  const [parentClientdata, setparentClientdata] = useState([]);
  const [rosterIdData, setrosterIdData] = useState([]);
  const [parentclientStatus, setparentclientStatus] = useState("");
  const [traineeStatus, setTraineestatus] = useState("");
  const [reasonStatus, setReasonstatus] = useState("");
  const [rosteridStatus, setrosteridStatus] = useState("");
  const [dropdownState, setdropdownState] = useState(true);
  const [rescheduleDetails, setRescheduleDetails] = useState("");
  const [rescheduleMove, setRescheduleMove] = useState("");
  const [defaultvalue, setdefaultvalue] = useState(0);
  const classTraineeId = useSelector((state) => state.bulkEdit);
  const parentClientCode = localStorage.getItem("parentClientCode");
  const roster = useSelector((state) => state.rosterConfig);
  const traineeRef = useRef(null);
  const reasonRef = useRef(null);
  const rosterRef = useRef(null);
  const menuProps = (ref) => ({
    PaperProps: {
      sx: {
        width: ref.current?.clientWidth,
        maxWidth: ref.current?.clientWidth,
      },
    },
    sx: {
      "& .MuiMenuItem-root": { whiteSpace: "normal", wordBreak: "break-word" },
    },
  });

  const rosterId = fromAssignTrainee
    ? classRosterId
    : classTraineeId.traineeDetails[0].classRosterId;

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  const errorResponse = (data) => {
    setSnack({
      open: true,
      message: `Failed to load ${data}`,
      severity: "error",
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      if (!cancelled) {
        setLoader(true);
      }

      try {
        const tResponse = await getTraineeStatus();

        if (cancelled) return;

        if (tResponse.message === "Success") {
          if (!cancelled) {
            settraineestatusdata(tResponse.data);
            setTraineestatus(tResponse.data[0].TraineeStatusId);
          }
        } else {
          if (!cancelled) {
            settraineestatusdata([]);
            setTraineestatus("");
            errorResponse("Trainee Status");
          }
        }

        const rResponse = await getreasonDetails(
          tResponse.data[0].TraineeStatusId,
        );

        if (cancelled) return;

        if (rResponse.message === "Success") {
          if (!cancelled) {
            setreasondata(rResponse.data);
            setReasonstatus(rResponse.data[0].TraineeStatusReasonId);
          }
        } else {
          if (!cancelled) {
            setreasondata([]);
            setReasonstatus("");
            errorResponse("Reason Status");
          }
        }

        const pResponse = await getparentClientList();

        if (cancelled) return;

        if (pResponse.message === "Success") {
          const parentClient = pResponse.data.parentClientDetails.map(
            (item, index) => ({
              parentClientName: item.parentClientName,
              id: index,
              parentClientCode: Number(item.parentClientCode),
            }),
          );

          if (!cancelled) {
            setparentClientdata(parentClient);

            const myVal =
              parentClient.findIndex(
                (o) => o.parentClientCode === parseInt(parentClientCode),
              ) || "";

            setdefaultvalue(myVal);
          }
        } else {
          if (!cancelled) {
            errorResponse("Parent Client");
          }
        }

        if (!cancelled) {
          rosterIdChangeHandler(parentClientCode);
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to fetch data:", error);
        }
      } finally {
        if (!cancelled) {
          setLoader(false);
        }
      }
    };

    fetchData();

    return () => {
      cancelled = true;
    };
  }, []);

  const rosterIdChangeHandler = async (parentClientCode) => {
    const response = await getRosterID(rosterId, parentClientCode);

    if (response.message === "Success") {
      await setrosterIdData(response.data);
      await setrosteridStatus(response.data[0].ClassRosterId);
    } else {
      setrosterIdData([]);
      setrosteridStatus("");
      errorResponse("Roster ID");
    }
  };

  const reasonChangeHandler = async (event) => {
    const response = await getreasonDetails(event.target.value);
    setreasondata(response.data);
    setReasonstatus(response.data[0].TraineeStatusReasonId);
  };

  const prepareTrainees = (data) => {
    return data.map((item) => ({
      classTraineeId: item.classTraineeId,
      oracleId: item.oracleId,
      candidateId: item.candidateId,
      preferredFirstName: item.preferredFirstName,
      preferredLastName: item.preferredLastName,
    }));
  };

  const saveHandler = async () => {
    setLoader(true);
    const trainees = prepareTrainees(
      fromAssignTrainee ? traineeDetails : classTraineeId.traineeDetails,
    );

    const obj = {
      existingClassRosterId: rosterId,
      newClassRosterId: rosteridStatus === "" ? null : rosteridStatus,
      trainees: trainees,
      modifiedBy: localStorage.getItem("User"),
      transferTraineeStatusId: traineeStatus,
      traineeStatusReasonId: reasonStatus,
      rescheduleTransferDetails: rescheduleDetails,
      rescheduledMovedToNewRoster: rescheduleMove,
    };

    const response = await saveRescheduleTransfer(obj);

    if (response.message === "Success") {
      setLoader(false);
      if (fromAssignTrainee !== true) {
        props.fetchData();
        props.onClose("right", true, "add");
      } else if (fromAssignTrainee === true) {
        onClose();
        refreshTraineeList();
      }

      const obj = {
        open: true,
        message: "Saved Succesfully !!",
        severity: "success",
      };

      dispatch(SnackBarStoreAction.updateSnack(obj));
    } else {
      setSnack({
        open: true,
        message: "Internal error occured.",
        severity: "error",
      });
      setLoader(false);
    }
  };

  let value = parentClientdata[defaultvalue]
    ? { ...parentClientdata[defaultvalue] }
    : null;

  return (
    <>
      {loading ? <BackdropComponent /> : null}

      <Grid container className={classes.container}>
        {fromAssignTrainee !== true && (
          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                px: 3,
                py: 2,
                borderBottom: "1px solid #e3e8ed",
              }}
            >
              <TextLabel fontSize={18} text={t("reschedule")} subHeading />
              <IconButton
                size="small"
                onClick={props.onClose}
                aria-label="Close"
              >
                <CloseIcon sx={{ color: grey[500] }} />
              </IconButton>
            </Box>
          </Grid>
        )}

        <Grid container spacing={3} sx={{ px: 3, pt: 3, pb: 1 }}>
          <Grid item xs={4}>
            <Typography sx={typographyStyle}>{t("traineeStatus")}</Typography>
            <FormControl fullWidth ref={traineeRef}>
              <Select
                fullWidth
                MenuProps={menuProps(traineeRef)}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={traineeStatus}
                sx={{ backgroundColor: "#FFF" }}
                inputProps={{ sx: { backgroundColor: "#fff" } }}
                onChange={(event) => {
                  setTraineestatus(event.target.value);
                  if (event.target.value === 3) setdropdownState(true);
                  else setdropdownState(false);
                  reasonChangeHandler(event);
                }}
              >
                {traineestatusdata.map((item) => (
                  <MenuItem
                    key={item.TraineeStatus}
                    value={item.TraineeStatusId}
                  >
                    {item.TraineeStatus}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <Typography sx={typographyStyle}>{t("reason")}</Typography>
            <FormControl fullWidth ref={reasonRef}>
              <Select
                fullWidth
                MenuProps={menuProps(reasonRef)}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={reasonStatus}
                sx={{ backgroundColor: "#FFF" }}
                onChange={(event) => {
                  setReasonstatus(event.target.value);
                }}
              >
                {reasondata.map((item) => (
                  <MenuItem
                    key={item.TraineeStatusReasonId}
                    value={item.TraineeStatusReasonId}
                  >
                    {item.TraineeStatusReason}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={4}>
            <Typography sx={typographyStyle}>{t("parentClient")}</Typography>
            <Autocomplete
              id="clear-on-escape"
              clearOnEscape
              options={parentClientdata}
              getOptionLabel={(option) =>
                option === null
                  ? ""
                  : option.parentClientName + "-" + option.parentClientCode
              }
              value={value}
              onChange={(event, option) => {
                setdefaultvalue(option === null ? defaultvalue : option.id);
                if (option)
                  rosterIdChangeHandler(
                    option === null ? "" : option.parentClientCode,
                  );
              }}
              renderInput={(params) => (
                <TextField {...params} sx={{ backgroundColor: "#fff" }} />
              )}
              disabled={dropdownState}
            />
          </Grid>

          <Grid item xs={12}>
            <Typography sx={typographyStyle}>
              {t("RosterId")}{" "}
              <Box component="i" sx={{ color: red[700], fontStyle: "italic" }}>
                (Note: Rosters with an Assign Trainees Lock will not be
                displayed)
              </Box>
            </Typography>
            <FormControl fullWidth sx={{ maxWidth: 400 }} ref={rosterRef}>
              <Select
                fullWidth
                MenuProps={menuProps(rosterRef)}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={rosteridStatus}
                onChange={(event) => setrosteridStatus(event.target.value)}
                sx={{ backgroundColor: "#FFF" }}
              >
                {rosterIdData.map((item) => (
                  <MenuItem
                    sx={{ whiteSpace: "normal" }}
                    key={item.ClassRoster}
                    value={item.ClassRosterId}
                  >
                    <p className={classes.dropdown}>{item.ClassRoster}</p>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={typographyStyle}>
              {" "}
              {t("rescheduleDetails")}
            </Typography>
            <TextField
              fullWidth
              id="outlined-multiline-flexible"
              multiline
              rows={3}
              className={classes.textarea}
              onChange={(e) => {
                setRescheduleDetails(e.target.value);
              }}
            ></TextField>
          </Grid>

          <Grid item xs={12}>
            <Typography sx={typographyStyle}>
              {t("rescheduleRoster")}
            </Typography>
            <TextField
              fullWidth
              id="outlined-multiline-flexible"
              multiline
              rows={3}
              className={classes.textarea}
              onChange={(e) => {
                setRescheduleMove(e.target.value);
              }}
            ></TextField>
          </Grid>

          {fromAssignTrainee !== true && (
            <Grid item xs={12}>
              <Typography sx={{ ...typographyStyle, color: red[700] }}>
                <i>{t("note")}</i>
              </Typography>
            </Grid>
          )}

          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1.5 }}>
              <CustomButton
                variant="outlined"
                onClick={props.onClose}
                sx={{ color: "#3299FF" }}
              >
                {t("cancel")}
              </CustomButton>
              <CustomButton
                variant="contained"
                onClick={(e) => saveHandler()}
                sx={{ backgroundColor: "#3299FF" }}
              >
                {t("submit")}
              </CustomButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
};
export default RescheduleOrTransferDrawer;
